/* Built In Imports */
import { useState, useEffect, useMemo, useCallback } from 'react';

/* External Imports */
import { Box, Button, Radio, RadioGroup, Text, Flex } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';
import NoSeatingAvailable from '@landing_pages/eoe/components/NoSeatingAvailable';

/* Services */
import { getCurrentRegion } from 'services/commonService';

/**
 * New Seating Layout Component based on the image design
 * @param {Object} sectionContent
 * @returns
 */
const SeatingLayoutEightRow2 = ({
  sectionContent,
  region,
  lang,
  pageData,
  listTicket,
  setListTicket,
  isCityClicked,
  selTab,
}) => {
  const [tokenId, setTokenId] = useState('');
  const [currRegion, setCurrRegion] = useState('in');

  console.log("listTicket", listTicket);

  // Memoized region fetching
  useEffect(() => {
    let isMounted = true;
    
    const fetchRegion = async () => {
      try {
        const cRegion = await getCurrentRegion();
        if (isMounted) {
          setCurrRegion(cRegion?.country?.toLowerCase() || 'in');
        }
      } catch (error) {
        if (isMounted) {
          setCurrRegion('in');
        }
      }
    };

    fetchRegion();
    
    return () => {
      isMounted = false;
    };
  }, []);

  // Memoized ticket row component
  const listEventTicketRow = useCallback((index) => {
    const ticket = listTicket?.tickets?.[index];
    if (!ticket) return null;

    const { name, json_pricing } = ticket;
    const price = json_pricing?.base?.original_price;
    const discountedPrice = json_pricing?.base?.price;

    const getColorForIndex = (idx) => {
      const colors = ['#185171', '#562D2F', '#0E3F3C', '#0E3F4F', '#0E3F3C', '#562D2F', '#185171'];
      return colors[idx] || 'inherit';
    };

    const InrRupees = new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
    });

    return (
      <Box
        height={"100%"}
        w={{base:"70px", sm:"70px",md:'160px' }}
        mx="auto"
        boxSizing="content-box"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        position="relative"
      >
        {/* {ticket?.json_pricing?.limited_seats_flag && (
          <Box
            bgColor="#D70000"
            color="#fff"
            fontSize={{ base: '8px', md: '10px' }}
            position="absolute"
            py={{ base: 1, md: 2 }}
            px={{ base: 2, md: 3 }}
            width={{ base: '66px', md: 'auto' }}
            fontFamily="'FedraSansStd-book'"
            zIndex="2"
            left="-6px"
            top="10px"
            _before={{
              width: 0,
              height: 0,
              content: "''",
              borderRight: '6px solid #870000',
              borderBottom: '6px solid transparent',
              borderTop: '0px solid #870000',
              position: 'absolute',
              left: 0,
              bottom: '-6px',
            }}
          >
            Limited Seats Available
          </Box>
        )} */}

        <Box key={index}>
          {ticket?.seats_available > 0 && (
            <>
              {name && (
                <RadioGroup
                  onChange={setTokenId}
                  value={tokenId}
                  size={{base:"sm", sm:"sm", md:"sm"}}
                  name={name}
                  marginLeft={{base:"0px", sm:"0px", md:"10px"}}
                >
                  <Radio
                    value={ticket?.token} //currRegion === "in" ? ticket?.cat_in : ticket?.cat_ov
                    bg="white"
                    border="none"
                    sx={{
                      '& .chakra-radio__control': {
                        width: { base: '6px', md: '10px' },
                        height: { base: '6px', md: '10px' },
                        minWidth: { base: '6px', md: '10px' },
                        minHeight: { base: '6px', md: '10px' },
                        maxWidth: { base: '6px', md: '10px' },
                        maxHeight: { base: '6px', md: '10px' },
                        fontSize: { base: '6px', md: '10px' },
                        '--chakra-sizes-3': { base: '6px', md: '10px' },
                        verticalAlign: 'middle',
                        marginTop: '0px',
                        marginBottom: '0px',
                        position: 'relative',
                        top: '0px',
                        transform: 'translateY(0)',
                        float: 'none',
                      },
                      '& .chakra-radio__control::before': {
                        width: { base: '6px', md: '10px' },
                        height: { base: '6px', md: '10px' },
                        minWidth: { base: '6px', md: '10px' },
                        minHeight: { base: '6px', md: '10px' },
                        maxWidth: { base: '6px', md: '10px' },
                        maxHeight: { base: '6px', md: '10px' },
                      },
                      '& .chakra-radio__control::after': {
                        width: { base: '6px', md: '10px' },
                        height: { base: '6px', md: '10px' },
                      },
                      '& .chakra-radio__label': {
                        marginLeft: { base: '3px', md: '2px' },
                        margin: '0px',
                        padding: '0px',
                        verticalAlign: 'middle',
                        lineHeight: '1',
                        position: 'relative',
                        top: '0px',
                        transform: 'translateY(0)',
                        float: 'none',
                      },
                      '& .chakra-radio': {
                        margin: '0px',
                        padding: '0px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        flexDirection: 'row',
                        gap: '0',
                      }
                    }}
                    _checked={{
                      background: 'none',
                      border: {base:'1px solid #fff', md:'2px solid #fff'},
                      outlineOffset: {base:'-5px', md:'-5px'},
                    }}
                  >
                    <Box
                      fontFamily="FedraSansStd-book"
                      fontSize={{ base: '7px', sm:'7px', md: '14px' }}
                      fontWeight="600"
                      lineHeight="1"
                      display="flex"
                      alignItems="center"
                    >
                      {name}
                    </Box>
                  </Radio>
                </RadioGroup>
              )}

              <Box
                display="flex"
                flexDir="column"
                fontSize={{ base: '7px', sm:'7px', md: '14px' }}
                fontWeight="600"
                paddingLeft={{base:"0px", sm:"12px", md:"18px"}}
                fontFamily="FedraSansStd-book"
                lineHeight={{base:"15px", sm:"15px", md:"25px"}}
              >
                <Text
                  paddingLeft={{ base: "10px", md: "14px" }}
                >
                  {discountedPrice === "Free" ? "(Free Seating)" : ""
                  //  InrRupees.format(discountedPrice).replace('₹', 'INR ').replace('.00', '')
                   }
                </Text>
                {/* {discountedPrice !== price && (
                  <Text
                    as="del"s
                    fontFamily="FedraSansStd-book"
                    color={getColorForIndex(index)}
                  >
                    {InrRupees.format(price).replace('₹', 'INR ').replace('.00', '')}
                  </Text>
                )} */}
              </Box>
            </>
          )}
          {/* {name && !ticket?.seats_available && (
            <NoSeatingAvailable
              name={name}
              price={price}
              discountedPrice={discountedPrice}
            />
          )} */}
        </Box>
      </Box>
    );
  }, [listTicket, tokenId, currRegion]);

  // Memoized GTM click handler
  const gtmClick = useCallback(() => {
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      
      window.dataLayer.push({
        event: 'MSR_Seating_Pass',
        city: "Coimbatore",
      });

      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: '',
          value: '',
          items: [{
            item_id: "Coimbatore",
            item_name: "MSR Seating Pass",
            location_id: "Coimbatore",
          }],
        },
      });
    }
  }, []);

  // Memoized button click handler
  const handleButtonClick = useCallback(() => {
    if (tokenId) {
      // Find the ticket object based on tokenId
      const selectedTicket = listTicket?.tickets?.find(ticket => ticket.token === tokenId);
      
      gtmClick();
      window.open(
        refineUrlDomain(`${config.MSR_EVENT_DOMAIN}/event/${currRegion === "in" ? config.MSR_EVENT_IN_ID : config.MSR_EVENT_OV_ID}/register?category=${currRegion == "in" ? selectedTicket?.cat_in : selectedTicket?.cat_ov}`),
        '_blank'
      );
    }
  }, [tokenId, currRegion, gtmClick, listTicket]);

  return (
    <Box
      display="flex"
      flexDir="column"
      alignItems="center"
      fontFamily="FedraSansStd-book"
      w={{ base: "100%", md: "750px" }}
      h="auto"
      mx="auto"
      position="relative"
      overflow="visible"
      px={{ base: 4, md: 0 }}
    >
      {/* Stage/Front Area - Centered at top */}
      <Box
        ml={{ base: "-24%", sm: "-24%", md: "-26%" }}
      >
        {/* Adiyogi Section */}
        <Box 
          position="relative"
          textAlign="center"
          zIndex="10"
          mb={{base:"1px", sm:"1px", md:"2px"}}
          w={{ base: "92px", sm: "92px", md: "239px" }}
          h={{ base: "41px", sm: "41px", md: "108px" }}
          bg="#E0E0CE"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="flex-end"
          padding="4px"
          overflow="visible"
        >
          {/* Image positioned to overlap background and head outside */}
          <Box
            position="absolute"
            w={{ base: "47px", sm: "47px", md: "123px" }}
            h={{ base: "37px", sm: "37px", md: "96px" }}
            top={{ base: "-20px", sm: "-20px", md: "-45px" }}
            left="50%"
            transform="translateX(-50%)"
            zIndex="20"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <img
              alt="adiyogi"
              title="adiyogi"
              src="https://www.datocms-assets.com/46272/1756805894-shiva_seating.png"
              loading="lazy"
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          </Box>
          {/* Text positioned at bottom with spacing from image */}
          <Text
            fontFamily="FedraSansStd-book"
            fontWeight="600"
            fontSize={{ base: "10px", md: "14px" }}
            lineHeight="100%"
            letterSpacing="0%"
            textAlign="center"
            color="#151515"
            mt={{ base: "8px", sm: "8px", md: "10px" }}
            mb={{ base: "1px", sm: "1px", md: "15px" }}
            zIndex="15"
          >
            Adiyogi
          </Text>
        </Box>
      
      <Box
        position="relative"
        w={{ base: "92px", sm: "92px", md: "239.53px" }}
        h={{ base: "21px", sm: "21px", md: "56.96px" }}
        bg="#E0E0CE"
        color="#151515"
        fontSize={{ base: "6px", sm: "6px", md: "12px" }}
        fontWeight="600"
        textAlign="center"
        fontFamily="FedraSansStd-book"
        padding="4px"
        display="flex"
        flexDir="column"
        alignItems="center"
        justifyContent="center"
        zIndex="10"
        mb={{base:"1px", sm:"1px", md:"2px"}}
      >   
        <Box
          mb={{base:"3px", sm:"3px", md:"10px"}}
          w={{ base: "13px", sm: "13px", md: "33px" }}
          h={{ base: "5px", sm: "5px", md: "12px" }}
        >
          <img
            alt="Yogeshwar Linga"
            title="Yogeshwar Linga"
            src={`${config.imgPath}/d/46272/1742963504-shiva_linga.png`}
            loading="lazy"
            //style={{ width: '33px', height: '12px' }}
          />
        </Box>
        <Text fontSize={{ base: "6px", sm: "6px", md: "12px" }}>Yogeshwar Linga</Text>
      </Box>
      
      <Box
        position="relative"
        w={{ base: "92px", sm: "92px", md: "239.53px" }}
        h={{ base: "40px", sm: "40px", md: "103.7px" }}
        bg="#E0E0CE"
        fontWeight="600"
        fontFamily="FedraSansStd-book"
        color="#151515"
        fontSize={{ base: "10px", sm: "10px", md: "14px" }}
        textAlign="center"
        padding={{ base: "10px", sm: "12px", md: "15px" }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        mb={{base:"-1px", sm:"-1px", md:"0"}}
      >
        Dais
      </Box>
      </Box>

      {/* Positioning container to center the 38px column under Dais */}
      <Box
        position="relative"
        w="100%"
        display="flex"
        justifyContent="center"
        mx="auto"
        marginTop={{ base: "0px", md: "0px" }}
      >
        {/* Main Seating Area - Three columns with proper proportions */}
        <Box
          position="relative"
          w={{ base: "300px", sm: "400px", md: "750px" }}
          h={{ base: "183px", sm: "183px", md: "460px" }}
          display="flex"
          flexDir="row"
          gap="0" 
          mx="auto"
          ml={{ base: "6px", sm: "0px", md: "0px" }}
        >
          {/* Left Seating Block - Fixed dimensions as per image */}
          <Box
            w={{ base: "100px", md: "260px" }}
            display="flex"
            flexDir="column"
            h={{ base: "auto", md: "auto" }}
            alignItems="flex-end"
            bg="#ADADAD"
            borderTop={{base:"1px solid #000", md:"2px solid #000"}}
            borderRight={{base:"1px solid #000", md:"2px solid #000"}}
            borderBottom={{base:"1px solid #000", md:"2px solid #000"}}
          >
            {/* Reserved (Top) - 259px width, 225px height */}
            <Box
              bg="#ADADAD"
              color="#FFFFFF"
              fontFamily="FedraSansStd-book"
              fontSize={{ base: "7px", sm:"7px", md: "14px" }}
              textAlign="center"
              h={{ base: "86px", md: "225px" }}
              w={{ base: "98px", md: "258px" }}
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontWeight="600"
              mb="2px"
            >
              <Text>Reserved</Text>
            </Box>

            {/* Brahmaputra - 198px width, 60px height, right aligned */}
            <Box
              bg="#FBAC45"
              color="#fff"
              as="label"
              cursor={!listTicket?.tickets[8]?.seats_available ? 'default' : 'pointer'}
              display="flex"
              justifyContent="center"
              alignItems="center"
              h={{ base: "23px", md: "60px" }}
              w={{ base: "76px", md: "198px" }}
              fontSize={{ base: "7px", md: "14px" }}
              fontFamily="FedraSansStd-book"
              //paddingTop={{ base: "10px", md: "15px" }}
              className="box-brahmaputra-middle"
              transition="all 0.2s ease"
              position="relative"
              //mb="2px"
              borderTop={{base:"1px solid #000", md:"2px solid #000"}}
              borderLeft={{base:"1px solid #000", md:"2px solid #000"}}
              borderBottom={{base:"1px solid #000", md:"2px solid #000"}}
              paddingLeft={{base:"7px", sm:"7px", md:""}}
            >
              {listEventTicketRow(8)}
            </Box>

            {/* Godavari - 198px width, 60px height, right aligned */}
            <Box
              bg="#B24D90"
              color="#fff"
              as="label"
              cursor={!listTicket?.tickets[9]?.seats_available ? 'default' : 'pointer'}
              display="flex"
              justifyContent="center"
              alignItems="center"
              h={{ base: "23px", md: "60px" }}
              w={{ base: "76px", md: "198px" }}
              fontSize={{ base: "7px", md: "14px" }}
              fontFamily="FedraSansStd-book"
              //paddingTop={{ base: "10px", md: "15px" }}
              className="box-godavari-middle"
              transition="all 0.2s ease"
              position="relative"
              //mb="2px"
             borderLeft={{base:"1px solid #000", md:"2px solid #000"}}
             paddingLeft={{base:"7px", sm:"7px", md:""}}


            >
              {listEventTicketRow(9)}
            </Box>

            {/* Cauvery - 260px width, 60px height */}
            <Box
              bg="#45478D"
              color="#fff"
              as="label"
              cursor={!listTicket?.tickets[10]?.seats_available ? 'default' : 'pointer'}
              display="flex"
              justifyContent="center"
              alignItems="center"
              h={{ base: "23px", md: "60px" }}
              w={{ base: "99.5px", md: "259px" }}
              fontSize={{ base: "7px", md: "14px" }}
              fontFamily="FedraSansStd-book"
              //paddingTop={{ base: "10px", md: "15px" }}
              className="box-cauvery-middle"
              transition="all 0.2s ease"
              position="relative"
              //mb="2px"
              paddingLeft={{base:"32%", sm:"32%", md:"25%"}}
              borderTop={{base:"1px solid #000", md:"2px solid #000"}}
            //borderLeft="2px solid #000"
              borderBottom={{base:"1px solid #000", md:"2px solid #000"}}


            >
              {listEventTicketRow(10)}
            </Box>

            {/* Reserved (Bottom) - 260px width, 60px height */}
            <Box
              //bg="#ADADAD"
              color="#FFFFFF"
              fontFamily="FedraSansStd-book"
              fontSize={{ base: "7px", md: "14px" }}
              textAlign="center"
              h={{ base: "23px", md: "60px" }}
              w={{ base: "100px", md: "260px" }}
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontWeight="600"
            >
              <Text>Reserved</Text>
            </Box>
          </Box>

          {/* New Column - 38px width with #E0E0CE background - Centered under Dais */}
          <Box
            w={{ base: "15px", md: "38px" }}
            h={{ base: "99.5%", md: "99.5%" }}
            bg="#E0E0CE"
            display="flex"
            alignItems="center"
            justifyContent="center"
            zIndex="10"
            position="relative"
          >
            {/* Column content if needed */}
          </Box>

          {/* Middle Seating Block - 8 sections as per image */}
          <Box
            w={{ base: "100px", md: "260px" }}
            display="flex"
            flexDir="column"
            h={{ base: "auto", md: "auto" }}
            bg={"#ADADAD"}
            position="relative"
            mr={{base:"5px", md:"10px"}}
            borderTop={{base:"1px solid #000", md:"2px solid #000"}}
            borderLeft={{base:"1px solid #000", md:"2px solid #000"}}
            borderBottom={{base:"1px solid #000", md:"2px solid #000"}}
          >
            {/* Reserved text for first 5 sections - positioned on right side */}
            <Box
              position="absolute"
              right={{base:"2px", md:"10px"}}
              top={{base:"43px", md:"125px"}}
              //transform="rotate(90deg)"
              transformOrigin="center"
              //bg="#ADADAD"
              color="#FFF"
              fontFamily="FedraSansStd-book"
              fontSize={{base:"7px", md:"14px"}}
              fontWeight="600"
              px={{base:"0px", md:"5px"}}
              py={{base:"0px", md:"5px"}}
              //zIndex="10"
            >
              Reserved
            </Box>

            {/* Section 1 - Sindhu & Sutlej */}
            <Box
              bg="#8980FA"
              color="#fff"
              as="label"
              cursor={!listTicket?.tickets[0]?.seats_available ? 'default' : 'pointer'}
              display="flex"
              justifyContent="center"
              alignItems="center"
              h={{ base: "23px", md: "54px" }}
              w={{ base: "65px", md: "171px" }}
              fontSize={{ base: "7px", md: "14px" }}
              fontFamily="FedraSansStd-book"
              //paddingTop="15px"
              className="box-sindhu-sutlej"
              transition="all 0.2s ease"
              position="relative"
              //mb="2px"
              pl={"6%"}

            borderRight={{base:"1px solid #000", md:"2px solid #000"}}
            borderBottom={{base:"1px solid #000", md:"2px solid #000"}}
            >
              {listEventTicketRow(0)}
            </Box>

            {/* Section 2 - Jehlum */}
            <Box
              bg="#A1AE10"
              color="#fff"
              as="label"
              cursor={!listTicket?.tickets[1]?.seats_available ? 'default' : 'pointer'}
              display="flex"
              justifyContent="center"
              alignItems="center"
              h={{ base: "23px", md: "54px" }}
              w={{ base: "65px", md: "171px" }}
              fontSize={{ base: "7px", md: "14px" }}
              fontFamily="FedraSansStd-book"
              //paddingTop="15px"
              className="box-jehlum"
              transition="all 0.2s ease"
              position="relative"
              //mb="2px"
              pl={"6%"}
            borderRight={{base:"1px solid #000", md:"2px solid #000"}}
            borderBottom={{base:"1px solid #000", md:"2px solid #000"}}
            >
              {listEventTicketRow(1)}
            </Box>

            {/* Section 3 - Hemavati */}
            <Box
              bg="#DC7152"
              color="#fff"
              as="label"
              cursor={!listTicket?.tickets[2]?.seats_available ? 'default' : 'pointer'}
              display="flex"
              justifyContent="center"
              alignItems="center"
              h={{ base: "23px", md: "54px" }}
              w={{ base: "65px", md: "171px" }}
              fontSize={{ base: "7px", md: "14px" }}
              fontFamily="FedraSansStd-book"
              //paddingTop="15px"
              className="box-hemavati"
              transition="all 0.2s ease"
              position="relative"
              //mb="2px"
              pl={"6%"}
            borderRight={{base:"1px solid #000", md:"2px solid #000" }}
            borderBottom={{base:"1px solid #000", md:"2px solid #000"}}
            >
              {listEventTicketRow(2)}
            </Box>

            {/* Section 4 - Tunga */}
            <Box
              bg="#9D72B8"
              color="#fff"
              as="label"
              cursor={!listTicket?.tickets[3]?.seats_available ? 'default' : 'pointer'}
              display="flex"
              justifyContent="center"
              alignItems="center"
              h={{ base: "23px", md: "54px" }}
              w={{ base: "65px", md: "171px" }}
              fontSize={{ base: "7px", md: "14px" }}
              fontFamily="FedraSansStd-book"
              //paddingTop="15px"
              className="box-tunga"
              transition="all 0.2s ease"
              position="relative"
              //mb="2px"
              pl={"6%"}
            borderRight={{base:"1px solid #000", md:"2px solid #000"}}
            borderBottom={{base:"1px solid #000", md:"2px solid #000"}}
            >
              {listEventTicketRow(3)}
            </Box>

            {/* Section 5 - Brahmaputra */}
            <Box
              bg="#FBAC45"
              color="#fff"
              as="label"
              cursor={!listTicket?.tickets[4]?.seats_available ? 'default' : 'pointer'}
              display="flex"
              justifyContent="center"
              alignItems="center"
              h={{ base: "23px", md: "60px" }}
              w={{ base: "65px", md: "171px" }}
              fontSize={{ base: "7px", md: "14px" }}
              fontFamily="FedraSansStd-book"
              //paddingTop="15px"
              className="box-brahmaputra-middle"
              transition="all 0.2s ease"
              position="relative"
              //mb="2px"
              pl={"6%"}
            borderRight={{base:"1px solid #000", md:"2px solid #000"}}
            >
              {listEventTicketRow(4)}
            </Box>

            {/* Section 6 - Godavari */}
            <Box
              bg="#B24D90"
              color="#fff"
              as="label"
              cursor={!listTicket?.tickets[5]?.seats_available ? 'default' : 'pointer'}
              display="flex"
              justifyContent="center"
              alignItems="center"
              h={{ base: "23px", md: "60px" }}
              w={{ base: "100px", md: "259px" }}
              fontSize={{ base: "7px", md: "14px" }}
              fontFamily="FedraSansStd-book"
              //paddingTop="15px"
              className="box-godavari-middle"
              transition="all 0.2s ease"
              position="relative"
              //mb="2px"
              paddingLeft={{base:"32%", sm:"32%", md:"25%"}}
              borderTop={{base:"1px solid #000", md:"2px solid #000"}}
              borderBottom={{base:"1px solid #000", md:"2px solid #000"}}
              borderRight={{base:"0.5px solid #000", md:""}}
            >
              {listEventTicketRow(5)}
            </Box>

            {/* Section 7 - Cauvery */}
            <Box
              bg="#45478D"
              color="#fff"
              as="label"
              cursor={!listTicket?.tickets[6]?.seats_available ? 'default' : 'pointer'}
              display="flex"
              justifyContent="center"
              alignItems="center"
              h={{ base: "23px", md: "60px" }}
              w={{ base: "100px", md: "259px" }}
              fontFamily="FedraSansStd-book"
              //paddingTop="15px"
              className="box-cauvery-middle"
              transition="all 0.2s ease"
              position="relative"
              //mb="2px"
              paddingLeft={{base:"32%", sm:"32%", md:"25%"}}
              borderBottom={{base:"1px solid #000", md:"2px solid #000"}}
              borderRight={{base:"0.5px solid #000", md:""}}
            >
              {listEventTicketRow(6)}
            </Box>

            {/* Section 8 - Reserved (moved to bottom) */}
            <Box
              bg="#ADADAD"
              color="#FFFFFF"
              fontFamily="FedraSansStd-book"
              fontSize={{ base: "7px", md: "14px" }}
              textAlign="center"
              h={{base: "23px", md: "60px" }}
              w={{base: "100px", md: "259px" }}
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontWeight="600"
              borderRight={{base:"0.5px solid #000", md:""}}
              //mb="0"
            >
              <Text fontSize={{ base: "7px", md: "14px" }}>Reserved</Text>
            </Box>
          </Box>

          {/* Right Free Seating Block - 30% width */}
          <Box
            w={{ base: "65px", md: "171px" }}
            h="100%"
            bg="#6DB4BE"
            color="#fff"
            display="flex"
            flexDir="column"
            alignItems="center"
            justifyContent="center"
            className="box-tamiraparani"
            //transition="all 0.2s ease"
            position="relative"
            cursor={!listTicket?.tickets[7]?.seats_available ? 'default' : 'pointer'}
            paddingLeft={{ base: "13px", md: "0px" }}
          >
            <Text
              fontFamily="FedraSansStd-book"
              fontSize={{ base: "7px", md: "14px" }}
              fontWeight="600"
              textAlign="center"
              px="10px"
              lineHeight="1.3"
            >
              {listEventTicketRow(7)}
            </Text>
          </Box>
        </Box>
      </Box>

      {/* Footer Content - Now positioned below the design */}
      <Box
        w={{base:"300px", md:"400px"}}
        fontWeight="400"
        fontStyle="italic"
        textAlign="center"
        //py="20px"
        mt={"20px"}
        mb="20px"
      >
        <StructuredTextParser
          fontFamily="FedraSansStd-book"
          str={render(sectionContent[2]?.body)}
          color="#FFFFFF"
          fontSize="18px"
          textAlign="center"
        />
      </Box>

      {/* Button - Now positioned below the design */}
      <Box mb="40px">
        {sectionContent[3]?.buttonText && (
          <Button
            disabled={!tokenId}
            fontFamily="FedraSansStd-book"
            fontWeight="600"
            color="#000000"
            fontSize="14px"
            className="btn_set"
            cursor={tokenId ? 'pointer' : 'not-allowed'}
            background={tokenId ? '#FFA735' : '#333333'}
            _hover={{
              background: tokenId ? '#FFA735' : '#333333',
            }}
            px="23px"
            py="15px"
            borderRadius="5px"
            maxW="149px"
            height="56px"
            onClick={handleButtonClick}
          >
            {sectionContent[3].buttonText}
          </Button>
        )}
      </Box>

      {/* Styles */}
      <style jsx global>
        {`
          .box-brahmaputra:hover {
            background: #FF8C42 !important;
            color: #fff !important;
          }
          .box-godavari:hover {
            background: #9D72B8 !important;
            color: #fff !important;
          }
          .box-cauvery:hover {
            background: #0E3F4F !important;
            color: #fff !important;
          }
          .box-sindhu-sutlej:hover {
            background: #978FFF !important;
            color: #fff !important;
          }
          .box-jehlum:hover {
            background: #B7C235 !important;
            color: #fff !important;
          }
          .box-hemavati:hover {
            background: #F38868 !important;
            color: #fff !important;
          }
          .box-tunga:hover {
            background: #B388CD !important;
            color: #fff !important;
          }
          .box-brahmaputra-middle:hover {
            background: #FFBB63 !important;
            color: #fff !important;
          }
          .box-godavari-middle:hover {
            background: #C466A4 !important;
            color: #fff !important;
          }
          .box-cauvery-middle:hover {
            background: #5E61A2 !important;
            color: #fff !important;
          }
          .box-tamiraparani:hover {
            background: #84C5CE !important;
            color: #fff !important;
          }
          .btn_set{
            opacity: 1 !important;
          }
          
          /* Override Chakra radio button sizing for mobile */
          @media (max-width: 767px) {
            .chakra-radio__control {
              width: 6px !important;
              height: 6px !important;
              min-width: 6px !important;
              min-height: 6px !important;
              max-width: 6px !important;
              max-height: 6px !important;
              font-size: 6px !important;
              vertical-align: middle !important;
              margin-top: 0 !important;
              margin-bottom: 0 !important;
              position: relative !important;
              top: 0 !important;
              transform: translateY(0) !important;
              float: none !important;
            }
            .chakra-radio__control::before {
              width: 6px !important;
              height: 6px !important;
              min-width: 6px !important;
              min-height: 6px !important;
              max-width: 6px !important;
              max-height: 6px !important;
            }
            .chakra-radio__control::after {
              width: 6px !important;
              height: 6px !important;
            }
            .chakra-radio__label {
              margin: 0 !important;
              padding: 0 !important;
              margin-left: 3px !important;
              vertical-align: middle !important;
              line-height: 1 !important;
              position: relative !important;
              top: 0 !important;
              transform: translateY(0) !important;
              float: none !important;
            }
            .chakra-radio {
              margin: 0 !important;
              padding: 0 !important;
              display: flex !important;
              align-items: center !important;
              justify-content: flex-start !important;
              vertical-align: middle !important;
              flex-direction: row !important;
              gap: 0 !important;
            }
            .chakra-radio-group {
              margin: 0 !important;
              padding: 0 !important;
            }
            /* Force consistent alignment for all mobile views */
            .chakra-radio * {
              display: flex !important;
              align-items: center !important;
              vertical-align: middle !important;
              line-height: 1 !important;
            }
            /* Ensure text alignment is consistent */
            .chakra-radio__label * {
              display: flex !important;
              align-items: center !important;
              line-height: 1 !important;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default SeatingLayoutEightRow2; 